import api from "./api"

export async function getActiveDomainConfigs(domain){
    return api.get(`/config/domain_configs/${domain}/active`)
}